// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"45":"b6a6a876","912":"f23d18ef"}[chunkId] + ".chunk.js";
};